<dyn-auth-widget-body
    title="No transactions avaialble">
</dyn-auth-widget-body>

@if (dynamicZyxDaemonService.$isLoggedIn()) {
    <dex-tx-history-w-content></dex-tx-history-w-content>
}
